import uk from './uk';

const languages = {
  en: '', // Uses default language from stimulsoft
  uk,
};

export type LanguageCode = keyof typeof languages;

export default languages;
